<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

    <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
      <userLeft :active="2" />
      <div class="box5">
        <div class="title">修改登录密码</div>
        <div style="width: 100%; height: 1px; background: #ede9e9; margin: 20px 0"></div>
        <div style="overflow: hidden">
          <div class="shuru_title">手机号</div>
          <a-input disabled placeholder="请输入手机号" style="float: left; width: 300px; margin-left: 20px"
            v-model="user_data.mobile" />
        </div>
        <div style="overflow: hidden;margin-top: 20px">
          <div class="shuru_title">验证码</div>
          <a-input placeholder="请输入图形验证码" style="float: left; width: 300px; margin-left: 20px;margin-right: 20px"
            v-model="tuxingcode" />
          <SIdentifyText :contentWidth="120" :contentHeight="32" :mobile="user_data.mobile"
            :changeCode.sync='identifyCodeText'>
          </SIdentifyText>
        </div>
        <div style="overflow: hidden; margin-top: 20px">
          <div class="shuru_title">原密码</div>
          <a-input v-model="oldPassword" type="password" autocomplete="new-password"
            style="float: left; width: 300px; margin-left: 20px" placeholder="请输入原密码" />
        </div>
        <div style="overflow: hidden; margin-top: 20px">
          <div class="shuru_title">新密码</div>
          <a-input v-model="passsword1" autocomplete="new-password" :type="passsword1_t ? 'tetx' : 'password'"
            style="float: left; width: 300px; margin-left: 20px" placeholder="请输入新密码" />
          <img @click="passsword1_t = !passsword1_t" v-if="passsword1_t" src="../assets/wangjimima_kanbujian.png" style="
              margin-top: 10px;
              width: 16px;
              height: 8px;
              float: left;
              margin-left: 10px;
              cursor: pointer;
            " alt="" />
          <img @click="passsword1_t = !passsword1_t" v-else src="../assets/wangjimima_kandejian.png" style="
              margin-top: 10px;
              width: 16px;
              height: 8px;
              float: left;
              margin-left: 10px;
              cursor: pointer;
            " alt="" />
        </div>
        <div style="overflow: hidden; margin-top: 20px">
          <div class="shuru_title">确认新密码</div>
          <a-input v-model="passsword2" :type="passsword2_t ? 'tetx' : 'password'"
            style="float: left; width: 300px; margin-left: 20px" placeholder="请再次输入新密码" />
          <img @click="passsword2_t = !passsword2_t" v-if="passsword2_t" src="../assets/wangjimima_kanbujian.png" style="
              margin-top: 10px;
              width: 16px;
              height: 8px;
              float: left;
              margin-left: 10px;
              cursor: pointer;
            " alt="" />
          <img @click="passsword2_t = !passsword2_t" v-else src="../assets/wangjimima_kandejian.png" style="
              margin-top: 10px;
              width: 16px;
              height: 8px;
              float: left;
              margin-left: 10px;
              cursor: pointer;
            " alt="" />
        </div>
        <div class="tijiao" @click="sumbit">确定</div>

        <div style="
            width: 100%;
            height: 1px;
            background: #ede9e9;
            margin-top: 100px;
          "></div>
        <div style="
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999;
            margin-top: 20px;
          ">
          <span style="color: #2b9a34">*</span>
          密码设定规则：6-16位字符，可包含数字、字母(区分大小写)、特殊符号
        </div>
      </div>
    </div>

    <foot />
  </div>
</template>

<script>
import axios from "axios";
import SIdentifyText from '../views/login/SIdentifyText.vue'
import userLeft from "../public/user_left";
import htmlHeader from "../public/head";
import foot from "../public/foot";
export default {
  name: "integral",
  components: {
    SIdentifyText,
    userLeft,
    htmlHeader,
    foot,
  },
  data() {
    return {
      user_data: {
        mobile: ''
      },
      tuxingcode: '',
      identifyCodeText: '',
      passsword1: "",
      passsword1_t: false,
      passsword2: "",
      passsword2_t: false,
      oldPassword: '',
    };
  },
  created() {
    this.get_user_info();
  },
  methods: {
    // 用户信息
    get_user_info() {
      this.api.user_info().then((res) => {
        this.user_data = res.data;
      });
    },
    sumbit() {
      if (this.tuxingcode == '' || this.tuxingcode !== this.identifyCodeText) {
        this.$message.error("请输图形验证码")
        return false
      }
      if (this.passsword1 == '' || this.passsword2 == '' || this.oldPassword == '') {
        this.$message.error("请输入密码")
        return false
      }
      if (this.newPassword != this.newPasswordCopy) {
        this.$message.error("两次密码不一致")
        return false
      }
      let obj = {
        oldPassword: this.oldPassword,
        newPassword: this.passsword1,
        newPasswordCopy: this.passsword2,
      }
      this.api.reset_password(obj).then(res => {
        if (res.ok) {
          this.$message.success(res.message)
          this.passsword1 = ''
          this.passsword2 = ''
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
};
</script>

<style scoped>
.shuru_title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  width: 100px;
  text-align: right;
  float: left;
  margin-top: 5px;
}

.title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.box5 {
  width: 80%;
  border: 1px solid #ede9e9;
  float: right;
  margin-top: 2%;
  padding: 2%;
}

.box3 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: Regular;
  color: #666666;
  margin-top: 6%;
}

.box4 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}

.box1 {
  width: 220px;
  min-height: 1023px;
  border: 1px solid #ede9e9;
  float: left;
  margin-top: 2%;
}

.box2 {
  width: 100%;
  height: 45px;
  background: #f2f2f2;
}

.type_title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 10px;
  margin-left: 20px;
}

.type_txt {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999;
  margin-top: 10px;
  margin-left: 20px;
}

.rich_text_box {
  width: 90%;
  float: left;
  margin-top: 25px;
  margin-left: 2%;
  height: 400px;
  overflow: hidden;
}

.tijiao {
  width: 100px;
  height: 40px;
  border: 1px solid #2b9a34;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2b9a34;
  margin-left: 120px;
  margin-top: 40px;
  margin-bottom: 40px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/chang_login_password.vue